export const oauthUserAgent = {
    CLIENT_ID: 'id-1234-5678-91011',
    URL_DEFAULT: '/o/c',
    URL_DEFAULT_NATIVE: '/o'
}

export const CONFIGURATION_BASE = {
    URL_DEFAULT: '',
}

export const OBJECT_MAPPING = {

}


export function getLanguageLocal() {
    return (Liferay.ThemeDisplay.getLanguageId()).replace("_", "-");
}